import { Injectable } from "@angular/core";
import { Location } from "@angular/common";

@Injectable({
    providedIn: "root",
})
export class SearchListLinkService {
    wasSearchResultsPage = false;

    constructor(private location: Location) {}

    setPreviouslyViewed(status: boolean): void {
        this.wasSearchResultsPage = status;
    }

    backInHistory(): void {
        this.location.back();
    }
}
